import { call, fork, put, takeLatest } from 'redux-saga/effects';
import { LOGOUT, LOGOUT_FORCE } from '../actions/actionTypes';
import { logoutDone, logoutLoading } from '../actions/logout';
import { authApi } from '../api/AuthApi';
import Logger from '../util/Logger';

export function* watchLogoutSaga () {
  yield takeLatest(LOGOUT, logoutSaga);
}

export function* watchLogoutForceSaga () {
  yield takeLatest(LOGOUT_FORCE, logoutForceSaga);
}

function* logoutForceSaga () {
  try {
    yield call(authApi.logout);
  } catch (error) {
    Logger.error('Error occurred during logout attempt', error);
  }
}

function* logoutSaga () {
  try {
    yield put(logoutLoading());
    yield call(authApi.logout);
  } catch (error) {
    Logger.error('Error occurred during logout attempt', error);
  } finally {
    // Regardless of what happens - we kick them back to /q and clear session state.
    // Worst case, logout fails and if they return back to dashboard they have no Redux and
    // cannot load anything on the page.
    yield put(logoutDone());
  }
}

export default [
  fork(watchLogoutSaga),
  fork(watchLogoutForceSaga)
];
